import { message } from 'antd'
import { ErrorBoundary } from '../common/error_boundary'
import { BodegaForm } from './forms/bodega'
import { HomeForm } from './forms/home'
import { LandingForm } from './forms/landing'
import { NewsletterForm } from './forms/newsletter'
import { PackForm } from './forms/pack'
import { ProductForm } from './forms/product'
import { TagForm } from './forms/tags'
import { ZonaForm } from './forms/zona'
import ProductProps from './properties/producto'
import TagProps from './properties/tag'
import { BodegaView } from './views/cellar_editor'
import { HomePathView } from './views/home'
import { HomeView } from './views/home_editor'
import { LandingView } from './views/landing_editor'
import { MenuView } from './views/menu_editor'
import { NewsletterView } from './views/newsletter_editor'
import { ProductView } from './views/product'
import { PromosView } from './views/promos_editor'
import { TagsView } from './views/tags'
import { TaxonomyView } from './views/taxonomy'
import { ZonaGeoView } from './views/zona_editor'
import { ZonasView } from './views/zonas'

const supportedMessageType = new Set(['error', 'warning', 'success'])

const registry = {
  paths: {
    '/zonas/': ZonasView,
    '/home/': HomePathView,
  },
  views: {
    ErrorBoundary: ErrorBoundary,
    Promos: PromosView,
    Bodega: BodegaView,
    Menu: MenuView,
    Landing: LandingView,
    Producto: ProductView,
    Tag: TagsView,
    Taxonomy: TaxonomyView,
    ZonaGeo: ZonaGeoView,
    Home: HomeView,
    //TODO
    Newsletter: NewsletterView,
  },
  forms: {
    Bodega: BodegaForm,
    Home: HomeForm,
    Landing: LandingForm,
    Producto: ProductForm,
    Packs: PackForm,
    Newsletter: NewsletterForm,
    Tag: TagForm,
    ZonaGeo: ZonaForm,
  },
  properties: {
    Producto: ProductProps,
    Tag: TagProps,
  },
}

const Cfg = {
  icons: {
    Promos: 'fa fa-percent',
    ZonaGeo: 'fas fa-globe',
    Producto: 'fas fa-wine-glass',
    Bodega: 'fas fa-seedling',
    Tag: 'fas fa-tag',
    Landing: 'fas fa-receipt',
    Home: 'fas fa-home',
    Newsletter: 'fas fa-envelope',
  },
  PageSize: 30,
  properties_default: ['@id', '@uid'],
  properties_ignore_fields: [
    'slug',
    'localized_text',
    'comentario',
    'image_header',
    'type_name',
    'title',
    'modification_date',
    'creation_date',
    'uuid',
    '__behaviors__',
  ],
  DelayActions: 2000,
  flash: (msg, type, duration = 5) => {
    if (supportedMessageType.has(type)) return message[type](msg)
    message.error(msg, duration)
  },
}

export default {
  registry,
  Cfg,
  url: '/db/guillotina/',
}
